var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFavMultiOn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 25.88,
    viewBox: "0 -0.94 24 25.88",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.382 17.607V.535H7.733v1.643l-3.726.524.242 1.722-3.63 1.041 4.706 16.41 14.495-4.156.794-.111zM9.155 1.958h12.804v14.226H9.155zM7.733 3.48v14.127h3.618l-3.87.544L5.463 3.799zM6.208 20.281 2.214 6.349l2.216-.635 1.953 13.894 4.263-.599z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21.991 7.555-4.439-.705-1.985-4.392-1.985 4.392-4.44.705 3.213 3.419-.758 4.827 3.971-2.279 3.971 2.279-.758-4.827zm-6.425 4.884-2.804 1.61.535-3.409-2.269-2.414 3.135-.497 1.402-3.102 1.402 3.102 3.135.497-2.269 2.414.535 3.409z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "red"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.619 23.304h7.596v1.391H.619zM15.785 23.304h7.596v1.391h-7.596zM11.044 23.304h1.911v1.391h-1.911z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFavMultiOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fav-multi-on.svg";